export default __webpack_public_path__ + "static/media/img_attach1_section4.342cb854.png";